import { useId } from 'react'
import { Sheet } from './Sheet'

/**
 * De bevestigingsdialoog uit ronde 10C, 10D en 11C: een vraag in de
 * display-font, een regel uitleg, en twee knoppen.
 *
 * De knopvolgorde verschilt bewust per breedte. Op mobiel staat de bevestiging
 * bovenaan omdat je duim daar zit; op desktop rechts, waar een dialoog zijn
 * primaire actie hoort te hebben. `flex-col-reverse` op desktop doet dat met
 * één klasse in plaats van met twee stukken JSX.
 */
export function ConfirmDialog({
  open,
  title,
  detail,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}: {
  open: boolean
  title: string
  detail: string
  confirmLabel: string
  cancelLabel: string
  onConfirm: () => void
  onCancel: () => void
}) {
  const headingId = useId()

  return (
    <Sheet open={open} onClose={onCancel} labelledBy={headingId}>
      <h2 id={headingId} className="font-display text-[28px] leading-[1.2] sm:text-[32px]">
        {title}
      </h2>

      <p className="text-ink-soft mt-2.5 text-sm leading-[1.5] text-pretty sm:text-[15px]">
        {detail}
      </p>

      <div className="mt-6 flex flex-col gap-2.5 sm:mt-6.5 sm:flex-row-reverse sm:justify-start sm:gap-2.5">
        <button
          type="button"
          onClick={onConfirm}
          className="bg-accent text-accent-ink flex h-13 items-center justify-center rounded-full px-6 text-base font-semibold active:scale-[0.99] sm:h-12.5"
        >
          {confirmLabel}
        </button>

        <button
          type="button"
          onClick={onCancel}
          className="border-line text-ink-muted flex h-13 items-center justify-center rounded-full border px-6 text-base active:scale-[0.99] sm:h-12.5"
        >
          {cancelLabel}
        </button>
      </div>
    </Sheet>
  )
}
